import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class MarketingToggle extends Component {
  /**
   *
   */
  bind(el: HTMLElement): void {
    super.bind(el);
    this.addListener(Notifications.ACTIVATE_PARENT_TOGGLE, () => {
      this.el.checked = true;
    });
  }
}
